import { createFileRoute } from '@tanstack/react-router';

import { TagListPage } from '~pages/tags/tag-list-page';

export const Route = createFileRoute('/_auth/_layout/category-config/tags')({
  component: TagListPage,
});
